import { AbstractControl } from '@angular/forms';

export function whitespace(c: AbstractControl) {
    if (c.value && !c.value.trim()) {
        return {
            whitespace: {
                valid: false,
            },
        };
    }
    return null;
}
